import { render } from "./family_list.vue?vue&type=template&id=6fab2390&scoped=true"
import script from "./family_list.vue?vue&type=script&lang=js"
export * from "./family_list.vue?vue&type=script&lang=js"

import "./family_list.vue?vue&type=style&index=0&id=6fab2390&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fab2390"]])

export default __exports__